import { Injectable } from "@angular/core";
import * as jsPDF from 'jspdf';
import * as html2canvas from 'html2canvas';

@Injectable()
export class PDFService {

  /**
   *
   * @param orientation L'orientation à appliquer au PDF.
   * @param unit L'unité.
   * @param format Le format du PDF.
   * Permet de créer une instance de PDF.
   */
  createPDF(orientation: string, unit: string, format: string): jsPDF {
    return new jsPDF(orientation, unit, format);
  }

  /**
   *
   * @param pdf Le pdf à manipuler.
   * @param margin La marge.
   * @returns la largeur à appliquer au PDF.
   * Permet d'obtenir la largeur à appliquer au PDF.
   */
  getPDFWidth(pdf: jsPDF, margin: number): number {
    return pdf.internal.pageSize.width - (margin * 2);
  }

  /**
   *
   * @param pdf
   *  Permet d'ajouter une page au PDF.
   */
  addPage(pdf: jsPDF): void {
    pdf.addPage();
  }

  /**
   *
   * @param pdf Le PDF à manipuler.
   * @param name Le nom du PDF.
   * Permet d'enregistrer le PDF.
   */
  save(pdf: jsPDF, name: string): void {
    pdf.save(name);
  }

  /**
   *
   * @param pdf Le PDF à manipuler.
   * @param printElement Le parent des éléments à imprimer.
   * @param margin La marge à appliquer au PDF.
   * @param pdfWidth La largeur à appliquer au PDF.
   * @param multipage Valeur booléenne indiquant si le PDF est multipage.
   * Permet de préparer le PDF dans sa globalité.
   */
  async printDiv(pdf: jsPDF, printElement: HTMLElement, margin: number, pdfWidth: number, multipage: boolean) {
    if (multipage) {
      for (var i = 0; i < printElement.children.length; i++) {
        await this.printDivInternal(pdf, printElement.children[i] as HTMLElement, margin, pdfWidth);
        // Ajouter une page sauf sur la dernière
        if (i + 1 < printElement.children.length) {
          this.addPage(pdf);
        }
      }
    }
    else {
      await this.printDivInternal(pdf, printElement, margin, pdfWidth);
    }
  }

  /**
   *
   * @param pdf Le PDF à manipuler.
   * @param printElement Le parent des éléments à imprimer.
   * @param margin La marge à appliquer au PDF.
   * @param pdfWidth La largeur à appliquer au PDF.
   * Permet de préparer une page du PDF.
   */
  private async printDivInternal(pdf: jsPDF, printElement: HTMLElement, margin: number, pdfWidth: number) {

    const divWidth = printElement.clientWidth;
    const divHeight = printElement.clientHeight;

    const imageWidth = pdfWidth;
    const imageHeight = divHeight * (pdfWidth / divWidth);

    const printOnly = document.getElementsByClassName('print-only');
    for (let i = 0; i < printOnly.length; i++) {
      const element = printOnly[i];
      if (element instanceof HTMLElement ) {
        element.style.visibility = 'visible';
      }
    }

    const canvas = await html2canvas(printElement, { allowTaint: true });
    canvas.getContext('2d');

    for (let i = 0; i < printOnly.length; i++) {
      const element = printOnly[i];
      if (element instanceof HTMLElement ) {
        element.style.visibility = 'hidden';
      }
    }

    const imgData = canvas.toDataURL('image/jpeg', 1.0);
    pdf.addImage(imgData, 'JPG', margin, margin, imageWidth, imageHeight);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-formulaire-demat/digicerba-formulaire-demat-web/src/angular/cerba/src/app/common/services/pdf.service.ts